import { render, staticRenderFns } from "./RecruitmentDetail.vue?vue&type=template&id=58b66a4a&scoped=true"
import script from "./RecruitmentDetail.vue?vue&type=script&lang=js"
export * from "./RecruitmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b66a4a",
  null
  
)

export default component.exports